import React, { Fragment } from 'react';
import { Redirect } from "react-router-dom";
import ReactPlayer from 'react-player';
import { Languages } from '../components/languages';
import { UIOrderPackageConfig, UISummary, UIFilterPanel, UISummaryWidget, UISummaryWidgetBar, PageTitle, UIDataTable, UIDownload, UIUpload, ScrollableGrid, ScrollableGridItem, UIPopup, UIInput, UIButton, UIButtonPad, UICheckbox, UIMessageBox, UISelect, UIMultiSelect } from '../components/guiElements';





export class How2SendaPro extends React.Component {
    constructor(props) {
        super(props);
        this.uc = JSON.parse(sessionStorage.getItem("userContext"));
        this.gotoCouriers = this.gotoCouriers.bind(this);
        this.gotoAPI = this.gotoAPI.bind(this);
        this.gotoShipping = this.gotoShipping.bind(this);
        this.le = Languages.getSection("HowToSendaPro");
        this.state = {
            player: false
        }
    }

    gotoCouriers() {
        this.props.navigateTo('TRACKING');
    }

    gotoAPI() {
        this.props.navigateTo('MARKETPLACES');        
    }

    gotoShipping() {
        this.props.navigateTo('ORDERS');   
    }
    
    componentDidMount() {
    }

    render() {


        const movie = this.state.player ? <UIPopup className="movie">
            <div className="popup-close" onClick={(ev) => { this.setState({ player: false }) }} />
            <ReactPlayer url={this.le.video.url} controls={true} playing={true}/>
        </UIPopup> : null

        return <div className="page-how2sendapro">
            <PageTitle icon="../images/mainMenu/HowToSendaPro.png" title={Languages.getSection('Main').menuLabels.howToSendapro} />
            <div className="page-content">

                <div className="firts-group">

                    <div className="first-row">
                        <div className="widget">
                            <div className="widget-content">
                                <div className="top-content">
                                    <div className="widget-content-title">
                                        {this.le.welcome + " " + (this.uc.firstName || this.uc.lastName)} !
                                    </div>
                                    <div className="widget-content-note">
                                        <p>{this.le.intro1}</p>
                                        <p>{this.le.intro2}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>



                    <div className="second-row">
                        <div className="camion"/>
                        <div className="widget">
                            <div className="widget-content">
                                <div className="widget-content-title with-icon ticket">
                                    {this.le.fatturazione.title}
                            </div>
                                <div>
                                    {this.le.fatturazione.desc}
                                </div>
                            </div>
                        </div>
                    </div>




                    <div className="third-row">


                        <div className="widget widget-api">
                            <div className="widget-content">
                                <div className="widget-content-title with-icon api">
                                    {this.le.api.title}
                                </div>
                                <div className="widget-content-body">
                                    <div>{this.le.api.desc1}</div>
                                    <div>{this.le.api.desc2}</div>
                                </div>
                                <UIButtonPad>
                                    <UIButton className="confirm" text={this.le.api.btn} onClick={this.gotoAPI} />
                                </UIButtonPad>
                            </div>
                        </div>

                        <div className="widget widget-shipping">
                            <div className="widget-content">
                                <div className="widget-content-title with-icon shipping">
                                    {this.le.shipping.title}
                                </div>
                                <div className="widget-content-body">
                                    <div>{this.le.shipping.desc1}</div>
                                    <div>{this.le.shipping.desc2}</div>
                                </div>
                                <UIButtonPad>
                                    <UIButton className="confirm" text={this.le.shipping.btn} onClick={this.gotoShipping} />
                                </UIButtonPad>
                            </div>
                        </div>

                        <div className="widget widget-couriers">
                            <div className="widget-content">
                                <div className="widget-content-title with-icon courier">
                                    {this.le.courier.title}
                                </div>
                                <div className="widget-content-body">
                                    <div>{this.le.courier.desc1}</div>
                                    <div>{this.le.courier.desc2}</div>
                                </div>
                                <UIButtonPad>
                                    <UIButton className="confirm" text={this.le.courier.btn} onClick={this.gotoCouriers} />
                                </UIButtonPad>
                            </div>
                        </div>

                    </div>
                </div>




                <div className="last-group">

                    <div className="widget widget-movie">
                        <div className="widget-content">
                            <div className="widget-content-title with-icon movie">
                                {this.le.video.title}
                            </div>
                            {/*<a href={this.le.video.url} target="_blank"><div className="link-movie"></div></a>*/}
                            <a onClick={() => (this.setState({ player: true }))} target="_blank"><div className="link-movie"></div></a>
                        </div>
                    </div>

                    <div className="widget widget-faq">
                        <div className="widget-content">
                            <div className="widget-content-title with-icon faq">
                                {this.le.faq.title}
                            </div>
                            <div className="widget-faq-item">
                                {
                                    this.le.faq.url1 ? <a href={this.le.faq.url1} target="_blank">{this.le.faq.link1}</a> : <div className="strong">{this.le.faq.link1}</div>
                                }
                                <div>{this.le.faq.desc1}</div>
                            </div>
                            <div className="widget-faq-item">
                                {
                                    this.le.faq.url2 ? <a href={this.le.faq.url2} target="_blank">{this.le.faq.link2}</a> : <div className="strong">{this.le.faq.link2}</div>
                                }
                                <div>{this.le.faq.desc2}</div>
                            </div>
                            <div className="widget-faq-item">
                                {
                                    this.le.faq.url3 ? <a href={this.le.faq.url3} target="_blank">{this.le.faq.link3}</a> : <div className="strong">{this.le.faq.link3}</div>
                                }
                                <div>{this.le.faq.desc3}</div>
                            </div>
                            <div className="widget-faq-footer">
                                {this.le.faq.foot1}<a href={this.le.faq.url4} target="_blank">{this.le.faq.foot2}</a>
                            </div>                                 
                        </div>
                    </div>
                </div>
            </div>
            {movie}
        </div>;

    }
}


    